<template>
   <v-dialog name="editRow" v-model="level.dialogValues.dialogShow" data-app="true" persistent max-width="900">
      <v-card>

         <CardUpdatableHeader :row="row" :level="level"/>

         <v-card-text>
            <v-container>
               <v-row dense>
                  <v-col cols="12" sm="6">
                     <v-text-field v-model="row.pro_code" :disabled="true" outlined :label="$t('texts._required_code')" :hint="$t('hints._code')">
                     </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                     <v-text-field v-model="row.prt_bm_entity_name" :disabled="true" outlined :label="$t('texts.producttype')" equired :hint="$t('hints.producttype')" persistent-hint>
                     </v-text-field>
                  </v-col>
               </v-row>
                  <v-col>
                     <v-text-field v-model="row.pro_name" :disabled="true" :label="$t('texts.pro_name')" :hint="$t('hints.pro_name')"></v-text-field>
                  </v-col>
               <h4>{{ $t('subtitles.html_presentation') }}</h4>
               <v-row dense>
                  <v-col>
                     <v-text-field v-model="row.pro_image_link" :disabled="level.dialogValues.form_disabled" :label="$t('texts.pro_image_link')" :hint="$t('hints.pro_image_link')"></v-text-field>
                  </v-col>
                  <v-col>
                     <div v-if="row.pro_image_link!=null">
                        <img v-bind:src="row.pro_image_link" width="50%" height="50%">
                     </div>
                  </v-col>
               </v-row>
               <v-row dense>
                  <v-col>
                     <template>
                        <br/>
                        <quill-editor
                           ref="myQuillEditor"
                           :disabled="level.dialogValues.form_disabled" 
                           v-model="content"
                           :options="options"
                        />
                        <br/>
                     </template>
                  </v-col>
               </v-row>
               <h4>{{ $t('subtitles.settings') }}</h4>
               <v-row dense no-gutters>
                  <v-col dense cols="12" sm="6">
                     <h5>{{ $t('subtitles.settings_zoho') }}</h5>
                     <v-switch
                        dense
                        v-model="row.pro_active"
                        :label="$t('texts.pro_active')"
                        :disabled="true"
                     >
                     </v-switch>
                     <v-switch
                        dense
                        v-model="row.pro_is_periodic"
                        :label="$t('texts.pro_is_periodic')"
                        :disabled="true"
                     >
                     </v-switch>
                     <v-col>
                        <v-text-field v-model="row.pro_price" :disabled="true" type="number" :label="$t('texts.pro_price')" :hint="$t('hints.pro_price')"></v-text-field>
                        <!--<v-currency-field label="Price" v-model="row.pro_price"></v-currency-field>-->
                        <v-text-field v-model="row.pro_setup_price" :disabled="true" type="number" :label="$t('texts.pro_setup_price')" :hint="$t('hints.pro_setup_price')"></v-text-field>
                     </v-col>
                  </v-col>
                  <v-col dense cols="12" sm="6">
                     <h5>{{ $t('subtitles.settings_local') }}</h5>
                     <v-switch
                        dense
                        v-model="row.pro_visible_on_front"
                        :label="$t('texts.pro_visible_on_front')"
                        :disabled="level.dialogValues.form_delete"
                     >
                     </v-switch>
                     <v-switch
                        dense
                        v-model="row.pro_default_plan"
                        :label="$t('texts.pro_default_plan')"
                        :disabled="level.dialogValues.form_delete"
                     >
                     </v-switch>
                     <v-col>
                        <v-text-field v-model="row.pro_yearly_price" :disabled="level.dialogValues.form_delete" type="number" :label="$t('texts.pro_yearly_price')" :hint="$t('hints.pro_yearly_price')"></v-text-field>
                        <v-text-field v-model="row.pro_yearly_setup_price" :disabled="level.dialogValues.form_delete" type="number" :label="$t('texts.pro_yearly_setup_price')" :hint="$t('hints.pro_yearly_setup_price')"></v-text-field>
                        <v-row>
                           <v-col>
                              <v-text-field v-model="row.pro_reseller_mrr_discount" suffix="%" min=0 max=100 :disabled="level.dialogValues.form_delete" type="number" :label="$t('texts.pro_reseller_mrr_discount')" :hint="$t('hints.pro_reseller_mrr_discount')" persistent-hint></v-text-field>
                           </v-col>
                           <v-col>
                              <v-text-field v-model="row.pro_reseller_nrr_discount" suffix="%" :disabled="level.dialogValues.form_delete" type="number" :label="$t('texts.pro_reseller_nrr_discount')" :hint="$t('hints.pro_reseller_nrr_discount')" persistent-hint></v-text-field>
                           </v-col>
                        </v-row>
                     </v-col>
                  </v-col>
               </v-row>
            </v-container>
         </v-card-text>

         <CardUpdatableFooter :row="row" :level="level"/>

         <v-card-text>
            <v-container>
               <div v-if="this.row.prt_is_bm_product">
               <h4>{{ $t('subtitles.plans') }}</h4>
               <v-row cols="auto">
                  <ddoClientList key="StartingList1" v-if="!listMode" :loading="loading" :level="levels[0]" 
                     :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
                     :customSlotNames="levels[0].customSlotNames"
                  >

                     <template v-slot:header="{ errors }">
                        <span></span>
                     </template>

                     <template slot="pro_flags" slot-scope="props">
                        <b-checkbox disabled v-model="props.row.pro_visible_on_front">{{$t('headers._visible')}}</b-checkbox>
                        <b-checkbox disabled v-model="props.row.pro_default_plan">{{$t('headers._default')}}</b-checkbox>
                     </template>

                     <template slot="pro_price" slot-scope="props">
                        <v-chip class="primary"><span>{{ $n(props.row.pro_price,'currency') }}</span></v-chip>
                     </template>

                     <template slot="pro_setup_price" slot-scope="props">
                        <v-chip class="primary"><span>{{ $n(props.row.pro_setup_price,'currency') }}</span></v-chip>
                     </template>

                     <template slot="pro_yearly_price" slot-scope="props">
                        <v-chip class="primary" v-if="props.row.pro_yearly_price!=null"><span>{{ $n(props.row.pro_yearly_price,'currency') }}</span></v-chip>
                     </template>

                     <template slot="pro_yearly_setup_price" slot-scope="props">
                        <v-chip class="primary" v-if="props.row.pro_yearly_setup_price!=null"><span>{{ $n(props.row.pro_yearly_setup_price,'currency') }}</span></v-chip>
                     </template>

                  </ddoClientList>

               </v-row>
               </div>
               <v-row>
                  <v-col v-if="!level.dialogValues.form_create" cols="12">
                     <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.pro_create,'long') }}<br/>
                     <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.pro_create,'long') }}
                  </v-col>
               </v-row>
            </v-container>
            <small>*{{ $t('texts.requiredfield') }}</small>
         </v-card-text>

      </v-card>
   </v-dialog>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import ddoSelect2 from '@/components/ddoSelect2.vue';
import ddoClientList from '@/components/ddoClientList.vue';
//import VCurrencyField from 'v-currency-field';
import VNumeric from 'vuetify-numeric/vuetify-numeric.umd'
import { quillEditor } from 'vue-quill-editor';

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

export default {
   name: 'CardUpdatableProductCategory',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      CardUpdatableHeader,
      CardUpdatableFooter,
      ddoClientList,
//      VCurrencyField,
      VNumeric,
      ddoSelect2,
      quillEditor,
   },

   props: {
   },

   data: function () {
      return {
         loading: false,
         listMode: false,

         editor: null,
         content: "",
         options: {},

         levels: [
         {
            api_code: 'product',
            api_prefix: 'pro',
            row: {},
            level: 0,
            errors: [],
            columns: [ 'pro_code', 'pro_name', 'pro_flags', 'pro_price', 'pro_setup_price', 'pro_yearly_price', 'pro_yearly_setup_price', '_update'],
            customSlotNames: ['pro_flags', 'pro_price', 'pro_setup_price','pro_yearly_price','pro_yearly_setup_price'],
            options: {
               showChildRowToggler: false,
               preserveState: true,
               withChild: false,
               hiddenColumns: [],
               headings: {
                  pro_code: i18n.t('headers.code'),
                  pro_name: i18n.t('headers.pro_name'),
                  pro_flags: i18n.t('headers._flags'),
                  pro_price: i18n.t('texts.pro_price'),
                  pro_setup_price: i18n.t('texts.pro_setup_price'),
                  pro_yearly_price: i18n.t('texts.pro_yearly_price'),
                  pro_yearly_setup_price: i18n.t('texts.pro_yearly_setup_price'),
                  _update: i18n.t('headers.updated_on')
               },
               texts: {
               },
               uniqueKey: 'pro_pk',
               columnsClasses: {
                  pro_price: 'text-right',
                  pro_setup_price: 'text-right',
                  pro_yearly_price: 'text-right',
                  pro_yearly_setup_price: 'text-right',
               },
               filterable: false,
               perPage: 50,
               perPageValues: [50,100,200],
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
               columnsDropdown: false,
               pagination: {
                  chunk: 5,
                  edge: false,
                  nav: 'scroll'
               },
            },
            callbacks: {
            },
         },
         ]
      }
   },

   created() {
      this.levels[0].callbacks.refresh_rows   = this.refresh_rows_l1;
   },

   watch: {
      'row': 'loadOtherInformations',
   },

   methods: {

      /*
       * We are not sure this function is really called on 'watch'. Seems not...
       */
      loadOtherInformations(row,oldRow) {
         /*
          * we correctly initialize the 'content' variable, from 'row.pro_html_content'
          */
         if ( row.pro_html_content ) {
            this.content = row.pro_html_content;
         }
      },

      change_content(content) {
         this.row.pro_html_content = content;
      },

      async refresh_rows_l1(key) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[0].api_code+'/'+this.row._pk+'/plans');
         this.loading = false;
         return { errorinfos, api_response }
      },
   }
   
}
</script>